import { Buffer } from 'buffer'
import { getAuthenticatedUser } from 'components/auth'
import { buildRequestURL, getChatToken, getRESTParams, REMBLE_API_URL } from '.'

/**
 * Returns an Event Source for the Remble API to stream responses
 * @param {Array<Object>} messages The messages array to send to Remble
 * Should be in the format of: { messages: [{ role: 'assistant', content: 'Hello' }, { role: 'user', content: 'Hi' }] }
 * @param {String} threadId The unique thread ID for this chat
 * @param {Array<String} filterWords An array of words to filter out of the response
 * @returns An Event Source
 */
const getChatEventSource = async (
  messages = [],
  threadId = null,
  filterWords = []
) => {
  const token = await getChatToken()
  const user = getAuthenticatedUser()
  const uri = `${REMBLE_API_URL}/chat/chat`

  // Convert the messages and filter words to a stringified JSON object
  let messagesString = JSON.stringify({ messages })
  let filterWordsString = JSON.stringify(filterWords)

  // Base64 encode the stringified JSON objects
  messagesString = Buffer.from(messagesString).toString('base64')
  filterWordsString = Buffer.from(filterWordsString).toString('base64')

  const url = buildRequestURL(uri, {
    messages: messagesString,
    token,
    user_id: user.aurora_id,
    thread_id: threadId,
    filter_words: filterWordsString
  })

  return new EventSource(url, getRESTParams())
}

export { getChatEventSource }
